<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vF3FaJ/images/cover.jpg?1684979561419" alt="This image is the cover for the book The Letter to Philemon, The New International Commentary on the New Testament"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Letter to Philemon, The New International Commentary on the New Testament
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>The Academy of Parish Clergy’s 2018 Top Five Reference Books for Parish Ministry</b><br/><br/> Paul's letter to Philemon carries a strong message of breaking down social barriers and establishing new realities of conduct and fellowship. It is also a disturbing text that has been used to justify slavery. Though brief, Philemon requires close scrutiny.<br/><br/> In this commentary Scot McKnight offers careful textual analysis of Philemon and brings the practice of modern slavery into conversation with the ancient text. Too often, McKnight says, studies of this short letter gloss over the issue of slavery—an issue that must be recognized and dealt with if Christians are to read Philemon faithfully. Pastors and scholars will find in this volume the insight they need to preach and teach this controversial book in meaningful new ways.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Scot McKnight
      </h2>
      
      <p class="authorDescription body article">Scot McKnight is Karl A. Olsson Professor in ReligiousStudies at North Park University, Chicago, Illinois. Hismany other books include The Jesus Creed: Loving God,Loving Others; A Community Called Atonement; NIVApplication Commentary volumes on Galatians and 1 Peter;and (coedited with James D. G. Dunn) The HistoricalJesus in Recent Research. He also writes theaward-winning Jesus Creed blog at patheos.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?506a21cc